
import * as React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import { Checkbox, FormControlLabel } from '@mui/material';
import { SET_ROOF_ZONES_AUTOFILL } from 'actions';


type Props = {
  dispatch: Function,
  panels: any,
};

class RoofZonesAutofill extends React.Component<Props, {}> {
  @autobind
  onChange(status: boolean) {
    const { dispatch } = this.props;
    dispatch(SET_ROOF_ZONES_AUTOFILL(status));
  }

  render() {
    const { panels: { enabledRoofZones } } = this.props;
    // return (
    // <SelectionControl
    //   id="roof-edges-autofill"
    //   type="checkbox"
    //   label="Roof Zones Autofill"
    //   name="Roof zones autofill"
    //   defaultChecked={enabledRoofZones}
    //   onChange={this.onChange}
    // />
    return (
      <FormControlLabel
        className="dsp-array-checkbox"
        control={
          <Checkbox
            checked={enabledRoofZones}
            onChange={(e) => this.onChange(e.target.checked)}
            name="roof-zones-autofill"
            color="primary"
          />
        }
        label="Roof Zones Autofill"
      />
    );
  }
}

function mapStateToProps(appState: appState): { panels: any } {
  return {
    panels: appState.panels,
  };
}

export default connect(mapStateToProps)(RoofZonesAutofill);
